<template>
  <div>
    <div class="d-flex align-center">
      <div class="text-4">Total Staked AUM</div>
    </div>
    <div class="mt-2 primary--text heading-3 font-weight-medium">
      ${{ totalVolume | numberFormat("0,0") }}
    </div>
    <div class="mt-2 d-flex align-center text-5">
      <span class="gray--text">24h</span>
      <span
        :class="[
          'font-weight-medium ml-1',
          {
            'green--text': change24h.percentage > 0,
            'red--text': change24h.percentage < 0,
            'darkgray--text': change24h.percentage === 0,
          },
        ]"
        ><span></span>
        <span
          ><span v-if="change24h.value < 0">–</span>${{
            change24h.value | abs | numberFormat("0,0")
          }}</span
        >
        <span class="ml-1"
          >(<span v-if="change24h.value < 0">–</span
          ><span v-if="change24h.value > 0">+</span
          ><span
            >{{
              change24h.percentage | abs | numberFormat("0,0.00", false)
            }}%</span
          >)</span
        ></span
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      historicalVolume: "productStats/historicalVolume",
      currentProject: "projectConfig/latestProject",
    }),
    totalVolume() {
      const all = this.historicalVolume.result?.details.stake[
        this.currentProject.projectName
      ];
      if (!all) return 0;
      return all.slice(-1)[0][1];
    },
    change24h() {
      if (!this.totalVolume)
        return {
          percentage: 0,
          value: 0,
        };
      const prev = this.historicalVolume.result?.details.stake[
        this.currentProject.projectName
      ].slice(-2)[0][1];
      return {
        percentage: ((this.totalVolume - prev) / this.totalVolume) * 100,
        value: this.totalVolume - prev,
      };
    },
  },
};
</script>
